var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('figure',{staticClass:"image is-16by9"},[_c('iframe',{staticClass:"has-ratio",attrs:{"width":"560","height":"315","src":_vm.url,"title":"YouTube video player","frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }